/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let progressBar = document.querySelector('.progress-bar');
if(progressBar){
    let flkty = new Flickity('.Carousel');

    flkty.on( 'scroll', function( progress ) {
    progress = Math.max( 0, Math.min( 1, progress ) );
    progressBar.style.width = progress * 100 + '%';
    });
}

class Dropdown {
    constructor(container) {
      this.isOpen = false;
      this.activeIndex = undefined;
  
      this.container = container;
      this.button = container.querySelector(".Collapsible__Button");
      this.menu = container.querySelector(".Collapsible__Inner");
      this.items = container.querySelectorAll(".HorizontalList__Item");
    }
  
    initEvents() {
      this.button.addEventListener("click", this.toggle.bind(this));
      document.addEventListener("click", this.onClickOutside.bind(this));
      document.addEventListener("keydown", this.onKeyEvent.bind(this));
    }
  
    toggle() {
      if(!document.querySelector('.PageOverlay.is-visible')) {
        this.isOpen = !this.isOpen;
        this.button.setAttribute("aria-expanded", this.isOpen);
        this.menu.setAttribute("aria-hidden", !this.isOpen);
        this.container.dataset.open = this.isOpen;
      }
    }
  
    onClickOutside(e) {
      if (!this.isOpen) return;
  
      let targetElement = e.target;
  
      do {
        if (targetElement == this.container) return;
  
        targetElement = targetElement.parentNode;
      } while (targetElement);
  
      this.toggle();
    }
  
    onKeyEvent(e) {
      if (!this.isOpen) return;
  
      if (e.key === "Tab") {
        this.toggle();
      }
  
      if (e.key === "Escape") {
        this.toggle();
        this.button.focus();
      }
  
      if (e.key === "ArrowDown") {
        this.activeIndex =
          this.activeIndex < this.items.length - 1 ? this.activeIndex + 1 : 0;
        this.items[this.activeIndex].focus();
      }
  
      if (e.key === "ArrowUp") {
        this.activeIndex =
          this.activeIndex > 0 ? this.activeIndex - 1 : this.items.length - 1;
        this.items[this.activeIndex].focus();
      }
    }
}
  
const dropdowns = document.querySelectorAll(".FiltersDropdown");
dropdowns.forEach((dropdown) => new Dropdown(dropdown).initEvents());
 
function checkUnits(){
  const cartList = document.querySelector(".Cart__ItemList");

  let shoeUnit = localStorage.getItem('shoe');
  let cmUnit = localStorage.getItem('cm');


  let shoeItems = document.querySelectorAll('.CartItem__Variant.shoe [data-unit="'+shoeUnit+'"]'),
      cmItems = document.querySelectorAll('.CartItem__Variant.cm [data-unit="'+cmUnit+'"]');

  shoeItems.forEach((unit) => {
    unit.style.display = 'inline-block';
  });

  cmItems.forEach((unit) => {
    unit.style.display = 'inline-block';
  });
}

window.sizes = () => {
  const sizeToggle = document.querySelector('.sizes-toggle');
  if(sizeToggle){
    const sizeType = sizeToggle.dataset.type,
          storedUnit = localStorage.getItem(sizeType);

    document.querySelectorAll('input[name="sizeUnit"], input[name="msizeUnit"]').forEach((input) => {
      input.addEventListener('change', (e) => {
        let unit = e.target.value,
            currentUnit = document.querySelectorAll(".size-unit[data-unit='"+unit+"']"),
            allUnits = document.querySelectorAll(".size-unit");

        localStorage.setItem(sizeType, unit);

        allUnits.forEach((item) => {
          item.style.display = 'none'
        });
        currentUnit.forEach((item) => {
          item.style.display = 'inline-block'
        });
      });
    });

    let unitInputs = document.querySelectorAll('input[value="'+storedUnit+'"]')

    unitInputs.forEach((input) => {
      input.checked = true;
      input.dispatchEvent(new Event('change'));
    });
  } 
}
window.sizes();

document.addEventListener('product:added', function(event) {
  setTimeout(function(){checkUnits()},500)
});

document.addEventListener('variant:changed', function(event) {
  let deliveryTime = document.querySelector('.ProductForm__EstimatedDelivery .time'),
      addToCart = document.querySelector('.ProductForm__AddToCart'),
      variant = event.detail.variant;

  let stockLevel = window.variantsStock[variant.id]

  if(stockLevel > 0) {
    deliveryTime.innerHTML = deliveryTime.dataset.standard;
    addToCart.querySelector('span').innerHTML = addToCart.dataset.standard;
  } else {
    deliveryTime.innerHTML = deliveryTime.dataset.preorder;
    addToCart.querySelector('span').innerHTML = addToCart.dataset.preorder;
  }
});

const isPLP = document.querySelector('.template-collection');
const isSearch = document.querySelector('.template-search');
const loadSwatches = function(){
  fetch('/collections/api?view=json')
    .then(response => response.json())
    .then(data => {
      const products = data;
      let relatedProducts = document.querySelectorAll('[data-handle]');

      relatedProducts.forEach(function(item){
        let handle = item.dataset.handle

        if(products.hasOwnProperty(handle)) {
          item.setAttribute('href', products[handle].url);
          item.querySelector('.item__Bg').style.backgroundImage = 'url('+products[handle].image+')'
        } else {
          item.remove();
        }
      });

      let swatches = document.querySelectorAll('.isSwatch');
      swatches.forEach(function(swatch){
        let count = swatch.querySelectorAll('.item--swatch').length
        if(count < 2) {
          swatch.classList.remove('isSwatch');        
        } else if(count > 4) {
          swatch.querySelector('.item--more span').innerHTML = '+'+parseFloat(count)-3
        } else {
          swatch.querySelector('.item--more').remove();
        }
      });
    });
}
if(isPLP || isSearch) {
  loadSwatches();
}

let lang = window.navigator.languages ? window.navigator.languages[0] : null;
    lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;

let shortLang = lang;
if (shortLang.indexOf('-') !== -1)
    shortLang = shortLang.split('-')[0];

if (shortLang.indexOf('_') !== -1)
    shortLang = shortLang.split('_')[0];

// if((shortLang != 'de' || shortLang != 'at') && !localStorage.hasOwnProperty('redirect')) {
//   window.location.replace("https://heinrich-dinkelacker-com.myshopify.com?redirect");
//   localStorage.setItem('redirect', 'global');
// }

// if((shortLang == 'de' || shortLang == 'at') && !localStorage.hasOwnProperty('redirect')) {
//   window.location.replace("https://heinrich-dinkelacker.myshopify.com?redirect");
//   localStorage.setItem('redirect', 'global');
// }

Array.from(document.querySelectorAll(".MegaMenu .Linklist__Item a")).forEach((item) => {
  if(item.innerHTML == "Crispinus Wochen") { item.style.color = "red";}
if(item.innerHTML == "Black Weeks") { item.style.color = "red";}
   if(item.innerHTML == "Sale") { item.style.color = "#111111";}
  if(item.innerHTML == "Season Sale") { item.style.color = "red";}
});

Array.from(document.querySelectorAll(".SidebarMenu__Nav a")).forEach((item) => {
  if(item.innerHTML == "Crispinus Wochen") { item.style.color = "red";}
    if(item.innerHTML == "Black Weeks") { item.style.color = "red";}
   if(item.innerHTML == "Sale") { item.style.color = "#111111";}
  if(item.innerHTML == "Season Sale") { item.style.color = "red";}
});

document.addEventListener("DOMContentLoaded", function () {
  var backToTopButton = document.getElementById("back-to-top");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 200) {
      backToTopButton.classList.add("show");
    } else {
      backToTopButton.classList.remove("show");
    }
  });

  backToTopButton.addEventListener("click", function () {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});